<template>
  <div class="m" style="background-color: #fafafa;">
    <NavBar />
    <div class="m-main">
      <h4 class="page-header">{{ $t('mobile.PwCYouPlusAnchorPro') }}</h4>
      <div class="content">
        <ul class="project-list">

          <li>
            <div class="clearfix" @click="open('/m/anchorDiscovery')">
              <!-- <img :src="projectImg3" onclick="return false"> -->
              <h5 v-if="lang === 'zh'" class="text-primary">普华永道 You Plus Anchor Pro 大学生职业能力培养体系</h5>
              <h5 v-else class="text-primary">PwC You Plus Anchor Pro Career Capability Training Platform</h5>
              <h4 v-if="lang === 'zh'" class="project-title">Anchor Discovery<br>商业实践和职业拓展综合项目</h4>
              <h4 v-else class="project-title">Anchor Discovery<br></h4>
              <p v-if="lang === 'zh'">打造名企职场胜任力 预定名企Offer机会</p>
              <p v-else>A comprehensive programme focusing on business practice and career development</p>
              <!-- <p v-else>Made-to-Order Career Capability<br>To Tier Offer Opportunities</p> -->
            </div>
          </li>

          <li>
            <div class="clearfix" @click="open('/m/anchorExplorer')">
              <!-- <img :src="projectImg4" onclick="return false"> -->
              <h5 v-if="lang === 'zh'" class="text-primary">普华永道 You Plus Anchor Pro 大学生职业能力培养体系</h5>
              <h5 v-else class="text-primary">PwC You Plus Anchor Pro Career Capability Training Platform</h5>
              <h4 v-if="lang === 'zh'" class="project-title">Anchor Explorer<br>商业实践和职业拓展综合项目</h4>
              <h4 v-else class="project-title">Anchor Explorer<br></h4>
              <p v-if="lang === 'zh'">打造名企职场胜任力 预定名企Offer机会</p>
              <p v-else>A comprehensive programme focusing on business practice and career development</p>
            </div>
          </li>

          <li>
            <div class="clearfix" @click="open('/m/anchorChallenger')">
              <!-- <img :src="projectImg2" onclick="return false"> -->
              <h5 v-if="lang === 'zh'" class="text-primary">普华永道 You Plus Anchor Pro 大学生职业能力培养体系</h5>
              <h5 v-else class="text-primary">PwC You Plus Anchor Pro Career Capability Training Platform</h5>
              <h4 v-if="lang === 'zh'" class="project-title">Anchor Challenger<br>商业实践和职业拓展综合项目</h4>
              <h4 v-else class="project-title">Anchor Challenger<br></h4>
              <p v-if="lang === 'zh'">打造名企职场胜任力 预定名企Offer机会</p>
              <p v-else>A comprehensive programme focusing on business practice and career development</p>
            </div>
          </li>

        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { common } from './common/mixin.js'
import projectImg1 from './../../assets/m/project-01.jpg'
import projectImg2 from './../../assets/m/project-02.jpg'
import projectImg3 from './../../assets/m/project-03.jpg'
import NavBar from './NavBar'
export default {
  name: 'CareerProgrammes',
  components: {
    NavBar
  },
  mixins: [common],
  data() {
    return {
      active: '',
      projectImg1,
      projectImg2,
      projectImg3
    }
  },
  // computed: {
  //   lang() {
  //     return this.$store.getters.language
  //   }
  // },
  watch: {
    $route: {
      handler(val) {
        const { cat } = val.params
        this.active = cat
      }
    }
  },
  mounted() {
    this.active = this.$route.params.cat
    console.log(this.active)
  },
  methods: {
    open(path) {
      if (path) {
        path.startsWith('http') ? window.open(path, '_self') : this.$router.push(path)
      }
    }
  }
}
</script>

<style>
.m .project-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.m .project-list li {
  background-color: #fff;
  margin-bottom: 0.3rem;
  border-radius: 0.08rem;
  box-shadow: 0 0.04rem 0.2rem rgba(0, 0, 0, 0.1);
}
.m .project-list li div {
  display: block;
  padding: 0.3rem;
  color: #333;
}
.m .project-list li .project-title {
  margin-bottom: 0.1rem;
  color: #d04a02;
  font-size: 0.32rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.m .project-list li p {
  margin-bottom: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  line-height: 150%;
}
.m .project-list li img {
  float: right;
  width: 1.4rem;
}
</style>
